import ClassNames from 'classnames'
import * as React from 'react'
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components'
import I18n from '../../core/i18n'
import * as constants from '../../static/constants'

interface IProps {
  onDrop: any
}

const maxSize = 20000000
const DropZoneUploader = React.memo<IProps>(props => {
  const { isDragActive, getRootProps, getInputProps, isDragReject, rejectedFiles } = useDropzone({
    accept: 'image/*',
    onDrop: props.onDrop,
    maxSize,
    minSize: 0,
  })
  const isFileTooLarge = rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize

  return (
    <DropZone
      {...getRootProps()}
      className={ClassNames('DropZoneUploader', 'file-drop-input', {
        active: isDragActive && !isDragReject,
        rejected: isDragReject || isFileTooLarge,
      })}
    >
      <input {...getInputProps()} />
      <p className="file-drop-input-text">
        {!isDragActive && I18n.t('dropzone.select_or_drag_and_drop')}
        {isDragActive && !isDragReject && I18n.t('dropzone.drop')}
        {isDragReject && I18n.t('dropzone.invalid_file')}
        {isFileTooLarge && I18n.t('dropzone.too_large')}
      </p>
    </DropZone>
  )
})

const DropZone = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(33.33% - 32px);
  height: 240px;
  border: dashed 2px ${constants.COLORS.divider};
  border-radius: 4px;
  margin: 24px 16px 0;
  padding: 8px;
  color: ${constants.COLORS.subText};
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &.active {
    color: ${constants.COLORS.primary};
    border: dashed 2px ${constants.COLORS.primary};
  }

  &.rejected {
    color: ${constants.COLORS.cautionText};
    border: dashed 2px ${constants.COLORS.caution};
  }
`

export default DropZoneUploader
